/**
 * Krok BRAND1 — JMENO PRODUKTU ZIJE NA JEDNOM MISTE.
 *
 * R.B. 6. 10. 2026: „domena a finalni nazev produktu bude Makléřov –
 * maklerov.cz". Co vidi clovek (makler, klient, kupujici) se jmenuje
 * **Makléřov**; co vidi jen stroj a vyvojar (balicky `@reos/*`, tabulky,
 * env promenne `REOS_*`, cesty `/opt/reos`, prefix MCP nastroju `reos.`)
 * se NEPREJMENOVAVA — je to interni identifikator, ne znacka.
 *
 * Proc tady a ne v `@reos/config`: jmeno produktu potrebuje i prohlizec
 * (web-admin, web-public, portal). `@reos/config` validuje serverove `env`
 * pres zod a do bundlu SPA nepatri; `@reos/i18n` uz v nem je, protoze odtud
 * jde kazdy text pro cloveka. Zadna dalsi kopie jmena v kodu neni —
 * hlida to `test/product-brand.spec.ts`.
 */
/** Nazev produktu pro cloveka. Jediny zdroj pravdy. */
export const PRODUCT_NAME = 'Makléřov';
/**
 * Nazev bez diakritiky. JEN tam, kde diakritika nejde: URL, slugy,
 * hlavicky protokolu (`user-agent`), nazvy souboru. Nikdy v proze —
 * ani v anglicke (zadani BRAND1: „bez diakritiky jen tam, kde diakritika
 * nejde").
 */
export const PRODUCT_NAME_ASCII = 'Maklerov';
/** Domena produktu. Preview bezi dal na `reos.preview.redhand.cz` (DNS je samostatny krok). */
export const PRODUCT_DOMAIN = 'maklerov.cz';
/**
 * Krok POWER1 (R.B. 6. 10. 22:15) — zneni domeny v podpisu „Powered by",
 * s diakritikou jako `PRODUCT_NAME`. Odkaz (`href`) pouziva `PRODUCT_DOMAIN`
 * (skutecny ASCII hostname); tohle je jen CO SE VIDI vedle slova „Powered by".
 */
export const PRODUCT_MARK_DOMAIN = `${PRODUCT_NAME}.cz`;
/** Znacka produktu v patickach dokumentu a klientskych stranek. */
export const PRODUCT_MARK = `${PRODUCT_NAME} · ${PRODUCT_DOMAIN}`;
/**
 * 6. pad pro cestinu („v Makléřově"). Pro texty, ktere NEJDOU pres katalog
 * (popisy MCP nastroju pro model). V katalogu se pouziva `{appLoc}`.
 */
export const PRODUCT_NAME_LOC = 'Makléřově';
/**
 * SKLONOVANI (jen cestina). „Makléřov" je bezne ceske podstatne jmeno vzoru
 * „Benešov", takze „v Makléřov" nebo „z Makléřov" je v textu pro cloveka
 * videt jako chyba. Tvary proto zije na jednom miste; kdyby R.B. chtel
 * znacku NESKLONNOU, staci sem napsat vsude `PRODUCT_NAME` a katalog se
 * nemeni (viz ROZHODNUTI BRAND1-SKLONOVANI v reportu kroku).
 */
const PRODUCT_FORMS_CS = {
    /** 1./4. pad — „Makléřov umí", „Připojte Makléřov" */
    app: PRODUCT_NAME,
    /** 2. pad — „vzory Makléřova", „z Makléřova" */
    appGen: 'Makléřova',
    /** 3. pad — „nech dohledat Makléřovu", „k Makléřovu" */
    appDat: 'Makléřovu',
    /** 6. pad — „v Makléřově", „o Makléřově" */
    appLoc: PRODUCT_NAME_LOC,
    /** 7. pad — „s Makléřovem" */
    appIns: 'Makléřovem',
};
/** Jazyky bez padu berou vsude zakladni tvar. */
const PRODUCT_FORMS_FLAT = {
    app: PRODUCT_NAME,
    appGen: PRODUCT_NAME,
    appDat: PRODUCT_NAME,
    appLoc: PRODUCT_NAME,
    appIns: PRODUCT_NAME,
};
/**
 * Vychozi ICU hodnoty, ktere `t()` doplnuje do KAZDE zpravy. Katalog proto
 * pise `{app}` / `{appDomain}` misto jmena natvrdo a prejmenovani produktu
 * je zmena jedne konstanty, ne 300 retezcu ve dvou jazycich.
 *
 * Jmena `app`/`appDomain` jsou schvalne: `{product}` i `{productName}` uz
 * v katalogu znamenaji NECO JINEHO (nazev reportu/tarifu v `@reos/commerce`),
 * prepsani by jim ticho podstrcilo jmeno produktu.
 */
export function productMessageValues(locale) {
    const base = locale.toLowerCase().startsWith('cs') ? PRODUCT_FORMS_CS : PRODUCT_FORMS_FLAT;
    return { ...base, appDomain: PRODUCT_DOMAIN, appMarkDomain: PRODUCT_MARK_DOMAIN };
}
/**
 * Dosadi jmeno produktu do SUROVEHO retezce z katalogu — pro kod, ktery
 * katalog cte jako data, ne pres `t()` (nápoveda verejneho webu si z nej
 * stavi index uryvku). Ostatni ICU argumenty (`{count}`, `{office}`)
 * zustavaji, aby je volajici poznal.
 */
export function substituteProduct(value, locale = 'cs') {
    const values = productMessageValues(locale);
    return value.replace(/\{(app[A-Za-z]*)\}/g, (match, name) => values[name] ?? match);
}
//# sourceMappingURL=product.js.map